
<marv-drawer #drawerEditDay     
    [showCloseButton]="false"
    [backdropDismiss]="false" 
    size="big"
    (onDidDismiss)="this.onDidDismissDrawerEditOrder($event)" 
    >
    <div class="title_card">{{'EDIT_ORDER' | translate}}</div>  
    @if(this.operation && this.customerPlanningSettings){
        <app-add-day 
            [operation]="this.operation" 
            [operationPlanningSetting]="this.customerPlanningSettings"             
            [orderDay]="this.orderDay" 
            (onChangeOrderDay)="this.onChangeOrderDay($event)"
            />
    }
</marv-drawer>

<ion-modal #modalDeleteOrder
    class="modal"    
    [canDismiss]="this.canDismissDeleteOrderModal.bind(this)"
    (didDismiss)="this.onDidDismissDeleteOrderModal($event)" 
    >   
    <ng-template>
        <ion-content class="ion-padding">
            <div class="btn_close_modal">
                <ion-icon name="close-outline" (click)="this.closeDeleteOrderModal()"></ion-icon>
            </div>
            <div class="title_card">{{'DELETE_ORDERS' | translate}}</div> 
            <form [formGroup]="this.deleteOrderForm" (ngSubmit)="this.deleteOrderOrActivity()">   
                <marv-button type="button" [label]="(this.toogleDeleteAllActivities ? this.translateService.instant('DELETE_ONLY_CURRENT_OCCURRENCE') : this.translateService.instant('DELETE_ALL'))" color="primary"  (click)="this.deleteAllActivities()"/>
                @if(this.missionDetails){
                    @for(a of this.missionDetails.activities; track $index){
                       <marv-checkbox 
                           label="{{a.day | epochToString}} {{(this.activityId === a.id ? ' ('+this.translateService.instant('CURRENT_OCCURRENCE')+')' : '')}}" 
                           [formName]="'activity_'+a.id"    
                           labelPlacement="end"
                           /> 
                   }
                }
                <ion-grid>
                    <ion-row class="ion-justify-content-around">                            
                        <ion-col size="auto">
                            <marv-button type="submit" label="{{ 'DELETE_ORDERS' | translate }}" icon="trash-outline" color="red" [isFetching]="this.isFetchingDelete"/>
                        </ion-col>                           
                        <ion-col class="no_padding" size="auto">
                            <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary"  (click)="this.closeDeleteOrderModal()"/>
                        </ion-col>                            
                    </ion-row>
                </ion-grid>
            </form>
        </ion-content>
    </ng-template>
</ion-modal>

<ion-modal #modalRequestCancellation
    class="modal"    
    [canDismiss]="this.canDismissRequestCancellationModal.bind(this)"
    (didDismiss)="this.onDidDismissRequestCancellationModal($event)" 
    >   
    <ng-template>
        <ion-content class="ion-padding">
            <div class="btn_close_modal">
                <ion-icon name="close-outline" (click)="this.closeRequestCancellationModal()"></ion-icon>
            </div>
            <div class="title_card">{{'REQUEST_CANCELLATION' | translate}}</div> 
            <marv-message type="error">
                {{ 'MSG_REQUEST_CANCELLATION_1' | translate }}<br><br>
                {{ 'MSG_REQUEST_CANCELLATION_2' | translate }}<br><br>
                {{ 'MSG_REQUEST_CANCELLATION_3' | translate }}
            </marv-message>
            <form [formGroup]="this.requestCancellationForm" (ngSubmit)="this.sendRequestCancellation()">
                <marv-textarea label="{{ 'COMMENTS' | translate }}" icon="information-circle-outline" formName="comments" [fixedLabel]="true" [withSpeechToText]="true"/>
                <ion-grid>
                    <ion-row class="ion-justify-content-around">                            
                        <ion-col size="auto">
                            <marv-button type="submit" label="{{ 'REQUEST_CANCELLATION' | translate }}" icon="checkmark-outline" color="primary" [isFetching]="this.isFetchingCancel" />
                        </ion-col>                           
                        <ion-col class="no_padding" size="auto">
                            <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary"  (click)="this.closeRequestCancellationModal()"/>
                        </ion-col>                            
                    </ion-row>
                </ion-grid>
            </form>
        </ion-content>
    </ng-template>
</ion-modal>

<ion-modal #modalAdditionalTime
    class="modal modal_additional_time" 
    [canDismiss]="this.canDismissAdditionalTimeModal.bind(this)"   
    (didDismiss)="this.onDidDismissAdditionalTimeModal($event)" 
    >   
    <ng-template>
        <ion-content class="ion-padding">
            <div class="btn_close_modal">
                <ion-icon name="close-outline" (click)="this.closeAdditionalTimeModal()"></ion-icon>
            </div>
            <div class="title_card">{{'ADDITIONAL_TIMES_BY_DAY' | translate}}</div> 
            <form [formGroup]="this.additionalTimesForm" (ngSubmit)="this.saveAdditionalTimes()">
                
                @for(at of this.additionalTimes; track $index){
                    <marv-sub-item>
                        <div class="additional_time">
                            <div class="additional_time_date">{{at.day | epochToString}}</div>
                            <marv-input type="number" label="{{'NB_HOURS' | translate}}" [formName]="'nb_hours_'+at.day" [fixedLabel]="true" />
                            <marv-input type="number" label="{{'NB_MINUTES' | translate}}" [formName]="'nb_minutes_'+at.day" [fixedLabel]="true" />
                        </div>
                    </marv-sub-item>
                }
                
                <ion-grid>
                    <ion-row class="ion-justify-content-around">                            
                        <ion-col size="auto">
                            <marv-button type="submit" label="{{ 'VALIDATE' | translate }}" icon="checkmark-outline" color="primary" />
                        </ion-col>                           
                        <ion-col class="no_padding" size="auto">
                            <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary"  (click)="this.closeAdditionalTimeModal()"/>
                        </ion-col>                            
                    </ion-row>
                </ion-grid>
            </form>
        </ion-content>
    </ng-template>
</ion-modal>

<marv-drawer #drawerPermanentStoreCheck (onDidDismiss)="this.onDidDismissDrawerPermanentStoreCheck($event)">    
    @if(this.missionDetails && this.storeCheckId){
        <app-permanent-planning-storecheck
            [operationId]="this.missionDetails.operation.id"
            [storeCheckId]="this.storeCheckId"
            (onChangeStoreCheck)="this.onChangeStoreCheck($event)"
            />
    }
</marv-drawer>

<marv-drawer #drawerPermanentStoreCheckDuplicate (onDidDismiss)="this.onDidDismissDrawerPermanentStoreCheckDuplicate($event)">    
    @if(this.missionDetails && this.storeCheckId){
        <app-permanent-planning-storecheck-duplicate
            [operationId]="this.missionDetails.operation.id"
            [storeCheckId]="this.storeCheckId"
            (onDuplicateStoreCheck)="this.onDuplicateStoreCheck($event)"
            />
    }
</marv-drawer>

<ion-content id="mission_details" class="no_padding" scroll-y="false">    
    @if(this.isFetching){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div>        
    }
    @else{
        @if(this.missionDetails){
            <div id="mission_details_content">
                <ion-grid class="no_padding">
                    <ion-row>
                        <ion-col class="no_padding">
                            <div class="title_card">{{'MISSION_DETAILS' | translate}}</div> 
                        </ion-col>
                        <ion-col class="no_padding" size="12" size-md="auto">
                            <div class="store_name">
                                @if(this.retailerLogo){
                                    <app-retailer-logo [retailer]="this.retailerLogo" />
                                }
                                <div>
                                    {{this.missionDetails.store.name}}
                                    <div class="mission_op">
                                        <marv-tag [color]="this.missionTypeService.getColor(this.missionDetails.operation.typeOfMission)" size="small">{{this.missionDetails.operation.name}}</marv-tag>
                                    </div>
                                </div>
                            </div>

                        </ion-col>
                    </ion-row>
                </ion-grid>

                <marv-tabs [tabs]="this.tabsMission">
                    <marv-tab tabId="infos">
                        <app-mission-details-infos [mission]="this.missionDetails" (onUpdateInfos)="this.onUpdateInfos($event)"/>
                    </marv-tab>
                    <marv-tab tabId="additional-data">
                        <app-mission-details-additional-data [mission]="this.missionDetails" />
                    </marv-tab>  
                    <marv-tab tabId="activities">
                        <app-mission-details-activities [mission]="this.missionDetails"/>
                    </marv-tab>
                    <marv-tab tabId="rating">
                        <app-mission-details-rating [mission]="this.missionDetails"/>
                    </marv-tab>
                </marv-tabs>

                @if(this.showFooterAction){
                    <ion-grid id="mission_details_footer">
                        <ion-row class="ion-justify-content-around">
                            
                            @if(this.showBtnEditOrder){
                                <ion-col class="no_padding" size="auto">
                                    <marv-button type="button" label="{{ 'EDIT_ORDER' | translate }}" icon="pencil-outline" color="primary" (click)="this.editOrder()"/>
                                </ion-col>
                            }                            
                            @if(this.showBtnDeleteOrder){
                                <ion-col class="no_padding" size="auto">
                                    <marv-button type="button" label="{{ 'DELETE_ORDER' | translate }}" icon="trash-outline" color="red" [isFetching]="this.isFetchingDelete" (click)="this.checkDeleteOrder()"/>
                                </ion-col>
                            }
                            @else if(this.showBtnRequestCancellationOrder){
                                <ion-col class="no_padding" size="auto">
                                    <marv-button type="button" label="{{ 'REQUEST_CANCELLATION' | translate }}" icon="close-circle-outline" color="red" [isFetching]="this.isFetchingCancel" (click)="this.openRequestCancellationModal()"/>
                                </ion-col>
                            }
                            @if(this.showBtnAdditionalTimeOrder){
                                <ion-col class="no_padding" size="auto">
                                    <marv-button type="button" label="{{ 'ADDITIONAL_TIMES' | translate }}" icon="time-outline" color="primary"  (click)="this.openAdditionalTimeModal()"/>
                                </ion-col>
                            }
                            
                            @if(this.showBtnEditStoreCheck){
                                <ion-col class="no_padding" size="auto">
                                    <marv-button type="button" label="{{ 'EDIT_STORECHECK' | translate }}" icon="pencil-outline" color="primary" (click)="this.editStoreCheck()"/>
                                </ion-col>
                            }
                            @if(this.showBtnDuplicateStoreCheck){
                                <ion-col class="no_padding" size="auto">
                                    <marv-button type="button" label="{{ 'DUPLICATE' | translate }}" icon="duplicate-outline" color="primary" (click)="this.duplicateStoreCheck()"/>
                                </ion-col>
                            }
                            @if(this.showBtnCancelStoreCheck){
                                <ion-col class="no_padding" size="auto">
                                    <marv-button type="button" label="{{ 'CANCEL_STORECHECK' | translate }}" icon="close-circle-outline" color="red" [isFetching]="this.isFetchingCancel" (click)="this.confirmCancelStoreCheck()"/>
                                </ion-col>
                            }
                            @if(this.showBtnDeleteStoreCheck){
                                <ion-col class="no_padding" size="auto">
                                    <marv-button type="button" label="{{ 'DELETE_STORECHECK' | translate }}" icon="trash-outline" color="red" [isFetching]="this.isFetchingDelete" (click)="this.confirmDeleteStoreCheck()"/>
                                </ion-col>
                            }
                        </ion-row>
                    </ion-grid>
                }
            </div>
        }
    }
</ion-content>